
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/password/edit",
      function () {
        return require("private-next-pages/users/password/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/password/edit"])
      });
    }
  